import React from "react"
import "./style.scss"
import Slider from "react-slick"
import { PORTFOLIO_LIST } from "../../data"

function HomePortfolioCarousel() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    fade:true
  }

  return (
    <div className="homePortfolioCarousel container">
      <Slider {...settings}>
        {PORTFOLIO_LIST.map((i, ind) => (
          <div className="row d-flex" key={ind}>
            <div className="col-12 col-md-5 pt-5 fs-5">
              Client
              <div className="fw-bold">{i.clientName}</div>
              <br />
              Project
              <div className="fw-bold">{i.projectType}</div>
              <br />
              {i.description}
              <br />
              <br />
              Visit{" "}
              <a href={i.url} className="text-purple projectLink">
                {i.urlPlaceholder}
              </a>
              <br />
              <br />
            </div>
            <div className="col-12 col-md-7">
              <img loading="lazy"  src={i.img} alt="" className="img-fluid projectImage" />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default HomePortfolioCarousel
